// extracted by mini-css-extract-plugin
module.exports = {"gameZone":"Main_gameZone__22OFk"};